import { useState } from "react";
import { Play } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const TEXTOS: Record<string, { reproducir: string; aviso: string }> = {
  es: { reproducir: "Reproducir el vídeo", aviso: "Se cargará desde YouTube (Google), que puede usar cookies." },
  en: { reproducir: "Play the video", aviso: "It will load from YouTube (Google), which may use cookies." },
  pt: { reproducir: "Reproduzir o vídeo", aviso: "Será carregado a partir do YouTube (Google), que pode usar cookies." },
  fr: { reproducir: "Lire la vidéo", aviso: "Elle sera chargée depuis YouTube (Google), qui peut utiliser des cookies." },
};

// Foto del aula (la misma de la portada): servida desde la propia web, no desde YouTube
const PORTADA = "/lovable-uploads/b01b136c-e0eb-4a4a-aa74-0d26afd9c08f.avif";

/**
 * Vídeo de YouTube que no contacta con Google hasta que la persona lo pide: antes solo hay una
 * portada local. Al pulsar se carga desde youtube-nocookie.com. Un iframe de youtube.com normal
 * deja cookies de Google (y llama a DoubleClick) sin consentimiento con solo hacer scroll.
 */
export const YouTubeVideo = ({ id, title }: { id: string; title: string }) => {
  const { language } = useLanguage();
  const [activo, setActivo] = useState(false);
  const t = TEXTOS[language] || TEXTOS.es;

  if (activo) {
    return (
      <iframe
        src={`https://www.youtube-nocookie.com/embed/${id}?autoplay=1`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        className="h-full w-full"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setActivo(true)}
      className="group relative flex h-full w-full flex-col items-center justify-center gap-2 bg-primary bg-cover bg-center p-4 text-center text-primary-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring sm:gap-4"
      style={{ backgroundImage: `url(${PORTADA})` }}
    >
      <span className="absolute inset-0 bg-primary/80" aria-hidden="true" />
      <span className="relative flex h-12 w-12 items-center justify-center rounded-full bg-primary-foreground text-primary transition-transform group-hover:scale-105 sm:h-16 sm:w-16">
        <Play className="ml-1 h-6 w-6 fill-current sm:h-8 sm:w-8" aria-hidden="true" />
      </span>
      <span className="relative text-base font-medium sm:text-lg">{t.reproducir}</span>
      <span className="relative max-w-sm text-xs opacity-90 sm:text-sm">{t.aviso}</span>
    </button>
  );
};
